import {OctTable} from "@oceantech/oceantech-ui";
import React, {useContext, useState} from "react";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";
import TextValidator from "../../component/TextValidator";
import {
  CODE_SUCCESS,
  ERROR_MESSAGE,
  textSystem,
} from "../../utils/Constant";
import {
  EVALUATE_STATUS,
} from "../constants/CorrectiveSubsectionModal";
import {saveCorrectiveSubsection} from "../services/CorrectiveSubsectionServices";
import {AppContext} from "../../appContext/AppContext";
import {IFile, IViewFile} from "../../models/models";
import {
  handleDownloadFileUtil,
  handleUploadFileUtil,
  handleViewFileUtil,
} from "../../utils/FileUtils";
import ViewFile from "../modals/ViewFile";
import {FileBtnGroup} from "./FileBtnGroup";
import {ICorrectiveSubsectionModalProps} from "../models/CorrectiveSubsectionModels";
import {useCSContext} from "../contexts";

const CorrectiveSubsectionTable = (props: ICorrectiveSubsectionModalProps) => {
  const {
    dataTable,
    setDataTable,
    objectSearch,
    setObjectSearch,
    configTable,
    handleDoubleClick,
    setTableCache,
    reload,
    setReload,
  } = props;
  const {setIsLoading} = useContext(AppContext);
  const {isView} = useCSContext();
  const [viewFile, setViewFile] = useState<IViewFile>({
    open: false,
    file: null,
  });

  const handleViewFile = async (file: IFile) => {
    const viewFile = await handleViewFileUtil(file, setIsLoading);
    if (viewFile) {
      setViewFile(viewFile);
    }
  };

  const handleDownloadFile = async (file: IFile) => {
    await handleDownloadFileUtil(file, setIsLoading);
  };

  const handleChangeTable = (
    index: number,
    value: any,
    field: string,
  ) => {
    const newDataTable = [...dataTable];

    if (field === "evidence") {
      handleUploadFileUtil(
        value,
        setIsLoading
      ).then((file: any) => newDataTable[index][field] = file);
    } else if (field === "status") {
      newDataTable[index][field] = value
        ? EVALUATE_STATUS.EVALUATED.code
        : EVALUATE_STATUS.NOT_RATE_YET.code;
    } else {
      newDataTable[index][field] = value;
    }

    setDataTable(newDataTable);
    const key = objectSearch?.level;
    setTableCache((prev: any) => ({
      ...prev,
      [key]: newDataTable,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const dataRequest = dataTable?.map((item: any) => {
      return {
        id: item?.id,
        criteriaSubsectionId: item?.criteriaSubsectionId,
        planCriteriaId: objectSearch?.planCriteriaId,
        fileId: item?.evidence?.id,
        fileName: item?.evidence?.name,
        pointSelfAssessment: item?.pointSelfAssessment?.id,
        conclusionAssessment: item?.conclusionAssessment?.id,
        comment: item?.comment,
        status: item?.status,
      };
    });
    setIsLoading(true);
    try {
      const {data} = await saveCorrectiveSubsection(dataRequest);
      if (data?.code === CODE_SUCCESS) {
        toast.success("Lưu thành công");
        setReload(!reload);
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  const correctiveSubsectionColumns = [
    {
      name: "Tên tiểu mục",
      field: "subsectionName",
      headerStyle: {
        width: "600px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div onDoubleClick={() => handleDoubleClick(row)}>
          <span className={`${row?.conclusionAssessment ? "text-navy" : ""}`}>
            {row?.subsectionName}
          </span>
        </div>
      ),
    },
    {
      name: "Bằng chứng",
      field: "evidence",
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex align-items-center justify-content-center">
          <label className="custom-file-upload">
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                handleChangeTable(index, file, "evidence");
              }}
            />
            {row?.evidence?.name ? (
              <span className="text-info">{row?.evidence?.name}</span>
            ) : (
              <span className="text-info">
                Tải tệp lên <i className="bi bi-upload text-navy ms-2"></i>
              </span>
            )}
          </label>
          {row?.evidence?.name && (
            <FileBtnGroup
              file={row?.evidence}
              onView={handleViewFile}
              onDownload={handleDownloadFile}
            />
          )}
        </div>
      ),
    },
    {
      name: "Ghi chú",
      field: "comment",
      cellStyle: {
        minWidth: "110px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <TextValidator
            className="spaces width-100"
            name="comment"
            value={row?.comment || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "comment");
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <OctTable
          id="searchCriteria"
          className={`table-background-th spaces h-calc-vh-242`}
          data={dataTable}
          columns={correctiveSubsectionColumns}
          searchObject={objectSearch}
          setSearchObject={setObjectSearch}
          fixedColumnsCount={-1}
          noToolbar={true}
          totalPages={configTable.totalPages}
          totalElements={configTable.totalElements}
          numberOfElements={configTable.numberOfElements}
          isShowSelection={false}
          clearToolbar={true}
          noPagination={true}
        />

        {!isView && (
          <div className="position-fixed bottom-0 end-0 p-3 w-100 d-flex justify-content-end border-top">
            <Button className="btn-fill min-w-100px" type="submit">
              Lưu
            </Button>
          </div>
        )}
      </form>

      {viewFile?.open && (
        <ViewFile
          show={viewFile?.open}
          file={viewFile?.file}
          onHide={() => setViewFile({open: false, file: null})}
        />
      )}
    </div>
  );
};

export default CorrectiveSubsectionTable;
